<div class="time-log-table table-responsive">
  @if (data.entries.length) {
    <div class="time-log-hours">
      <span>Hours Worked: {{ data.totalWorkingHours }}h</span>
      <span class="separator">│</span>
      <span>Working Hours in {{ monthNameGetter + ': ' + data.totalMonthWorkingHours }}h</span>
    </div>
  }
  <table class="table">
    <thead class="thead-light">
      <tr>
        @if (!timeLogDialog()) {
          <th scope="col" style="width: 10%">#</th>
          <th scope="col" style="width: 50%">
            {{ 'LOG_TIME.INPUT.DESCRIPTION' | translate }}
          </th>
          <th scope="col" style="width: 10%">
            {{ 'LOG_TIME.INPUT.HOURS' | translate }}
          </th>
          <th scope="col" style="width: 20%">
            {{ 'LOG_TIME.TABLE.DATE' | translate }}
          </th>
          <th scope="col" style="width: 10%">
            {{ 'SHARED.ACTIONS' | translate }}
          </th>
        }
        @if (timeLogDialog()) {
          <th scope="col" style="width: 20%">
            {{ 'LOG_TIME.TABLE.DATE' | translate }}
          </th>
          <th scope="col" style="width: 10%">
            {{ 'LOG_TIME.INPUT.HOURS' | translate }}
          </th>
          <th scope="col" style="width: 50%">
            {{ 'LOG_TIME.INPUT.DESCRIPTION' | translate }}
          </th>
          <th scope="col" style="width: 10%">
            {{ 'SHARED.ACTIONS' | translate }}
          </th>
        }
      </tr>
    </thead>

    <tbody>
      @if (isLoading) {
        <div class="table-overlay">
          <mat-spinner [diameter]="16"></mat-spinner>
        </div>
      }

      @for (entry of data.entries; track entry) {
        <tr>
          @if (!timeLogDialog()) {
            <th scope="row">{{ entry.id }}</th>
            <td>{{ entry.description }}</td>
            <td>{{ entry.hours }}</td>
            <td>{{ entry.date }}</td>
          }
          @if (timeLogDialog()) {
            <td>{{ entry.date }}</td>
            <td>{{ entry.hours }}</td>
            <td>{{ entry.description }}</td>
          }
          <td class="actions">
            <button
              mat-icon-button
              aria-label=""
              (click)="toggleEditingEntry(entry.id)"
              [disabled]="isLoading"
            >
              @if (editingEntryId !== entry.id) {
                <mat-icon>edit</mat-icon>
              }
              @if (editingEntryId === entry.id) {
                <mat-icon>close</mat-icon>
              }
            </button>
            <button
              mat-icon-button
              color="warn"
              aria-label=""
              (click)="deleteEntry(entry.id)"
              [disabled]="isLoading"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
        @if (editingEntryId === entry.id) {
          <tr>
            <td colspan="5">
              <app-time-log-input mode="edit" [entry]="entry" />
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
</div>
